import { helpLinks } from "../../model/ASPLinks";
import { Link } from "react-router-dom";
import './ResourceLinkNav.css'

const ResourceLinkNav = (props) => {
    return (
        <>
            <div className="col-xl-9">
                {props.children}
            </div>
            <div className="col-xl-3 row g-1 gy-3 pt-0 default-page">
                <div className='container'>
                    <div className='card card-body'>
                        <div className='resource-nav-title'>Additional Resources</div>
                        <hr className='mt-0' />
                        <div className='row g-3'>
                            {helpLinks.map((link, index) => {
                                return link.displayName !== 'Dashboard' && 
                                <div key={index} className="resource-nav-link">
                                    {link.route ?
                                        <Link className="btn text-decoration-none" to={link.route}>
                                            {link.displayName}
                                        </Link>
                                        :
                                        <a href={link.homeUrl} className="btn text-decoration-none" target="_blank" rel="noopener noreferrer">
                                            {link.displayName}
                                        </a>
                                    }
                                </div >
                            }
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ResourceLinkNav;